import { ColorsConfig } from '@ddt-web/config';
import { NumberUtil } from '@ddt-web/generic-utils';

export const BOX_PLOT_CHART_CONFIG = {
	chart: {
		type: 'boxplot',
		height: 310,
		style: {
			fontFamily: '"FortBook", Arial, sans-serif'
		}
	},
	xAxis: {
		visible: false,
		min: 0,
		max: 6
	},

	yAxis: {
		title: { text: '' },
		min: 0,
		tickAmount: 6,
		labels: {
			formatter: function (): any {
				const label = this.axis.defaultLabelFormatter.call(this);
				const tickInterval = this.axis.tickInterval;
				if (!isNaN(label) && tickInterval % 1 !== 0) {
					return NumberUtil.formatNumber(Number(label), 1);
				}
				return label;
			}
		}
	},
	plotOptions: {
		column: {
			minPointLength: 3
		},
		line: {
			marker: {
				enabled: false
			}
		}
	},
	series: [
		{
			type: 'boxplot',
			borderRadius: 5,
			data: null,
			whiskerLength: '30%',
			whiskerColor: ColorsConfig.BOX_CHART_COLORS.WHISKER,
			fillColor: ColorsConfig.BOX_CHART_COLORS.FILL,
			medianWidth: 3,
			whiskerWidth: 2,
			color: ColorsConfig.BOX_CHART_COLORS.DEFAULT,
			pointStart: 3,
			pointWidth: 70,
			medianColor: ColorsConfig.BOX_CHART_COLORS.MEDIAN,
			stemColor: ColorsConfig.BOX_CHART_COLORS.STEM,
			stemWidth: 2,
			tooltip: {
				enabled: false,
				headerFormat: '',
				pointFormat: ''
			}
		},
		{
			type: 'scatter',
			data: null,
			cursor: 'pointer',
			tooltip: {
				enabled: false,
				headerFormat: '',
				pointFormat: ''
			},
			marker: {
				radius: 7
			},
			pointPlacement: 'on'
		}
	]
};
